import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import LifeProposerDetailsForm from 'src/components/BuyPolicy/insuranceScreens/life/forms/LifeProposerDetailsForm'
import LifeMemberDetailsForm from 'src/components/BuyPolicy/insuranceScreens/life/forms/LifeMemberDetailsForm'
import LifeNomineeDetailsForm from 'src/components/BuyPolicy/insuranceScreens/life/forms/LifeNomineeDetailsForm'
import { COLORS } from 'src/utils/Themes/colors'
import { Button } from '@mui/material'
import { useHistory } from 'react-router-dom'
import arrow from 'src/assets/Buy_Policy_Images/arrow.svg'
import { FORM_ERROR } from 'src/utils/constants/life'

const LifeMemberDetails = () => {
  const classes = useStyles()
  const history = useHistory()

  const lifeReducerData = useSelector((state) => state?.buyPolicyLifeReducer)

  const providerDetails = {
    occupation: [],
    maritalStatus: [],
  }

  const initialValues = {
    proposerDetails: lifeReducerData?.proposerDetails ?? {},
    insuredMembers: lifeReducerData?.insuredMembers ?? [],
    nomineeDetails: lifeReducerData?.nomineeDetails ?? {},
  }

  const validationSchema = Yup.object().shape({
    proposerDetails: Yup.object().shape({
      fullName: Yup.string().required(FORM_ERROR?.REQUIRED),
      firstName: Yup.string().required(FORM_ERROR?.REQUIRED),
      lastName: Yup.string().nullable(),
      dateOfBirth: Yup.date().required(FORM_ERROR?.REQUIRED),
      email: Yup.string().email(FORM_ERROR?.INVALID_EMAIL).nullable(),
      phone: Yup.number().required(FORM_ERROR?.REQUIRED),
      height: Yup.number().nullable(),
      weight: Yup.number().nullable(),
      panNumber: Yup.string().nullable(),
      aadharNumber: Yup.string().nullable(),
      isNominee: Yup.boolean(),
      age: Yup.number().required(FORM_ERROR?.REQUIRED),
      relation: Yup.string().required(FORM_ERROR?.REQUIRED),
      gender: Yup.string().required(FORM_ERROR?.REQUIRED),
      maritalStatus: Yup.string().nullable(),
      profession: Yup.string(),
      address: Yup.object().shape({
        permanentAddress: Yup.object().shape({
          addressLine: Yup.string().nullable(),
          landmark: Yup.string().nullable(),
          pincode: Yup.string().nullable(),
          city: Yup.string().nullable(),
          state: Yup.string().nullable(),
        }),
        currentAddress: Yup.object().shape({
          addressLine: Yup.string().nullable(),
          landmark: Yup.string().nullable(),
          pincode: Yup.string().nullable(),
          city: Yup.string().nullable(),
          state: Yup.string().nullable(),
        }),
        isCurrentAddressPermanent: Yup.boolean(),
      }),
    }),
    insuredMembers: Yup.array().of(
      Yup.object().shape({
        id: Yup.number().required(FORM_ERROR?.REQUIRED),
        firstName: Yup.string().nullable(),
        lastName: Yup.string().nullable(),
        dateOfBirth: Yup.date().required(FORM_ERROR?.REQUIRED),
        height: Yup.number().nullable(),
        weight: Yup.number().nullable(),
        isNominee: Yup.boolean(),
        age: Yup.number().required(FORM_ERROR?.REQUIRED),
        relation: Yup.string().required(FORM_ERROR?.REQUIRED),
        gender: Yup.string().required(FORM_ERROR?.REQUIRED),
        maritalStatus: Yup.string().required(FORM_ERROR?.REQUIRED),
      })
    ),
    nomineeDetails: Yup.object().shape({
      firstName: Yup.string().nullable(),
      lastName: Yup.string().nullable(),
      dateOfBirth: Yup.date().required(FORM_ERROR?.REQUIRED),
      relation: Yup.string().required(FORM_ERROR?.REQUIRED),
      gender: Yup.string().required(FORM_ERROR?.REQUIRED),
    }),
  })

  const lifeMemberDetailsForm = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true)
      handleSubmit(values)
    },
    enableReinitialize: true,
  })

  const handleSubmit = () => {}

  const handleBack = () => {
    history.push('/individual/dashboard/buyPolicy/life/insuranceDetails')
  }

  const handleProceed = () => {
    history.push(
      '/individual/dashboard/buyPolicy/life/insuranceDetails/terms-and-conditions'
    )
  }

  return (
    <form onSubmit={lifeMemberDetailsForm.handleSubmit}>
      <div className={classes.root}>
        <div
          onClick={handleBack}
          className={classes.goBackButtonContainer}
          id='backButton'
        >
          <img src={arrow} alt='arrow' />
          <span className={classes.gotoBackButton}>Go back</span>
        </div>

        <div className={classes.formSection}>
          <div className={classes.mainHeading}>Proposer Details</div>
          <LifeProposerDetailsForm
            lifeMemberDetailsForm={lifeMemberDetailsForm}
          />
        </div>

        <hr className={classes.separator} />

        <div className={classes.mainHeading}>Insured Member Details</div>
        <>
          {lifeMemberDetailsForm?.values?.insuredMembers?.length ? (
            <div>
              {lifeMemberDetailsForm?.values?.insuredMembers?.map(
                (member, index) => (
                  <div
                    className={classes.formSection}
                    key={`memberDetails_${member?.id}`}
                  >
                    <LifeMemberDetailsForm
                      lifeMemberDetailsForm={lifeMemberDetailsForm}
                      memberIndex={index}
                      providerDetails={providerDetails}
                    />
                    <hr className={classes.insuredMemberSeparator} />
                  </div>
                )
              )}
            </div>
          ) : null}
        </>

        <hr className={classes.separator} />

        <div className={classes.formSection}>
          <div className={classes.mainHeading}>Nominee Details</div>
          <LifeNomineeDetailsForm
            lifeMemberDetailsForm={lifeMemberDetailsForm}
          />
        </div>

        <div className={classes.actionsContainer}>
          <Button
            variant='outlined'
            className={classes.backButton}
            onClick={handleBack}
          >
            Back to Quotes
          </Button>
          <Button
            variant='contained'
            className={classes.proceedButton}
            onClick={handleProceed}
          >
            Proceed
          </Button>
        </div>
      </div>
    </form>
  )
}

export default LifeMemberDetails

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  mainHeading: {
    fontSize: '18px',
    color: COLORS.DARK_PINK,
    fontWeight: '600',
  },
  separator: {
    margin: 'unset',
    width: '100%',
    borderColor: COLORS.DARK_PINK,
    opacity: '0.2',
  },
  insuredMemberSeparator: {
    margin: 'unset',
    width: '100%',
    borderColor: '#29AACD',
    opacity: '0.2',
  },
  actionsContainer: {
    display: 'flex',
    gap: '20px',
  },
  backButton: {
    borderColor: '#29AACD !important',
    color: '#29AACD !important',
  },
  proceedButton: {
    backgroundColor: `${COLORS.DARK_PINK} !important`,
    color: '#ffffff !important',
  },
  goBackButtonContainer: {
    display: 'flex',
    cursor: 'pointer',
    gap: '5px',
    marginBottom: '10px',
  },
  gotoBackButton: {
    fontSize: '12px',
    border: '1px',
    backgroundColor: 'white',
    cursor: 'pointer',
  },
})
